import React, { FC } from 'react';

import AppDownloadQR from '../AppDownloadQR';
import AppDownloadSendMeLink from './components/SendMeLink';

interface Props {
  className?: string;
  qrSubtitle?: string;
  qrLayout?: 'vertical' | 'horizontal';
}

export const AppDownload: FC<Props> = ({ className, qrLayout, qrSubtitle }) => {
  return (
    <div className={className}>
      <AppDownloadQR layout={qrLayout} title={qrSubtitle} />
      <div className="mt-8">
        <AppDownloadSendMeLink />
      </div>
    </div>
  );
};

export default AppDownload;
